import React from "react";
import { useTranslation } from "react-i18next";

import { legendItemStyle, legendStyle } from "./style";

const FlashFlood72hEULegend = () => {
  const { t } = useTranslation();

  return (
    <div style={legendStyle}>
      <div>
        <b>{t("riskAssessment.flashflood")} (ITA) - 72h</b>
      </div>
      <div>
        <span style={legendItemStyle("#f9f9f9")}></span>
        {t("levels.low")}: 0 &lt; pp level (mm/h) &lt; 1
      </div>
      <div>
        <span style={legendItemStyle("#d0efff")}></span>
        {t("levels.moderate")}: 1 &le; pp level (mm/h) &lt; 2.5
      </div>
      <div>
        <span style={legendItemStyle("#187bcd")}></span>
        {t("levels.significant")}: 2.5 &le; pp level (mm/h) &lt; 5
      </div>
      <div>
        <span style={legendItemStyle("#03254c")}></span>
        {t("levels.high")}: pp level (mm/h) &ge; 5
      </div>

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "x-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          pp level = {t("legend.flashFloodLevel")}
        </span>
      </div>
      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          © CyStellar, {t("legend.dataFromRAIN")}
        </span>
      </div>
    </div>
  );
};

export default FlashFlood72hEULegend;
